import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { SeparatorFieldParams } from 'SharedDir/declarations/fields';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SeparatorField',
},
  __name: 'Separator',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {


const props = __props;
const size = computed(() => {
  if (props.params.height === 'small') {
    return '2px';
  }
  if (props.params.height === 'medium') {
    return '4px';
  }
  if (props.params.height === 'big') {
    return '8px';
  }

  return '';
});

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createBlock(_component_q_separator, { size: size.value }, null, 8, ["size"]))
}
}

})